import { AfterContentChecked, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, FormArray, Validators, FormBuilder } from '@angular/forms';
import { createPopper } from '@popperjs/core';
import { MatPasswordStrengthComponent } from '@angular-material-extensions/password-strength';
import swal from 'sweetalert2';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { LoginService } from '../../services/login.service';
import { Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent extends FeaturesBaseComponent implements OnInit,AfterContentChecked {
  resetForm: FormGroup;
  password: string;
  showDetails: boolean = false;
  color = '';

  @ViewChild('passwordComponentWithConfirmation', { static: true })
  passwordComponentWithConfirmation: MatPasswordStrengthComponent;

  constructor(private cdref: ChangeDetectorRef, private router: Router,
    private formBuilder: FormBuilder, private loginService: LoginService
  ) {
    super();
  }
  ngAfterContentChecked() {
    this.passwordComponentWithConfirmation.max = 12;
    this.cdref.detectChanges();

  }

  ngOnInit() {
    super.ngOnInit();

    // this.passwordComponentWithConfirmation.passwordFormControl.valueChanges.subscribe(() => {
    //   console.log('passwordFormControl form control = ', this.passwordComponentWithConfirmation.passwordFormControl);
    // });

    // this.passwordComponentWithConfirmation.passwordConfirmationFormControl.valueChanges.subscribe(() => {
    //   console.log('passwordFormControl form control = ', this.passwordComponentWithConfirmation.passwordConfirmationFormControl);
    // });
    this.resetForm = new FormGroup({
      password: new FormControl(this.passwordComponentWithConfirmation.passwordFormControl),
      confirmPassword: new FormControl(this.passwordComponentWithConfirmation.passwordConfirmationFormControl),
    });
  }

  toggleHint() {
    this.showDetails = !this.showDetails;
  }

  onStrengthChanged(strength: number) {
    // console.log('password strength = ', strength);
  }

  submit() {
    if (this.resetForm.value.password.status == "INVALID" || this.resetForm.value.confirmPassword.status == "INVALID") {
      // console.log(this.resetForm.value.password)
      // console.log(this.resetForm.value.confirmPassword) 
      return;
    }
    let _userName = JSON.parse(localStorage.getItem('userVerify')).username;
    if (_userName && this.resetForm.value.confirmPassword.value) {
      let httpParams = new HttpParams()
        .set('userName', _userName)
        .set('password', this.resetForm.value.confirmPassword.value)
      this.loginService.resetPassword(httpParams).subscribe(res => {
        console.log(res)
        if (res.httpcode == 200) {
          
          swal.fire(
            'Success!', 'Password reset successfully!', 'success'
          )
          this.router.navigate(['/'])
        }
      })
    }

  }
  getPasswordHint():string{

    return `should contain at least one lower character.\n should contain at least one upper character.\n should contain at least one digit character.\n should contain at least one special character.\nshould contain at least 8 characters.`

  }
}